module.exports = __webpack_public_path__ + "img/thumbs_up.7b86b9af.png";